import React, { Component } from "react";

export default class AcessoNegadoContainer extends Component {
  render() {
    return (
      <div className="animated fadeIn">
        <div className="text-center">
          <h1 className="display-1 text-danger">
            <i className="fa fa-frown-o" />
          </h1>
          <p className="text-danger">Sem Acesso!</p>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/autenticacao/SemAcesso.js